/**
 * created by wang lei
 时间页面
 *
 */
import React, {Component} from 'react';
import time from './time.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class TimeTool extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <span style={{cursor:"pointer"}} onClick={()=>{
                this.props.editor.execCommand( 'time');
            }}>
                <img className={"editor-time-tool-btn"} src={time}/>
                 <style>{`
                .editor-time-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-time-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-time-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style>
            </span>
        )
    }

}